import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconCloudOff(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m3.88 2.851.021.021 9.78 9.78.021.021 2.189 2.189a.668.668 0 0 1-.943.943l-1.919-1.919a4.042 4.042 0 0 1-.943.114H6.097A6 6 0 0 1 2.368 3.225L.281 1.138a.668.668 0 0 1 .943-.943L3.88 2.851zm-.558 1.328a4.667 4.667 0 0 0 2.764 8.488h5.724zM12.086 6a3.999 3.999 0 0 1 3.688 5.56.668.668 0 0 1-1.228-.52 2.669 2.669 0 0 0-2.459-3.707h-.84a.666.666 0 0 1-.646-.503 4.666 4.666 0 0 0-4.112-3.5.666.666 0 1 1 .118-1.328 6 6 0 0 1 5.136 3.997z"
  }));
}
IconCloudOff.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconCloudOff.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconCloudOff as default };
